<div>
  <app-grants-accordion />
</div>
